import React, { Component } from "react";
/*import StatusIcon from '../component/StatusIcon';*/

export default class ActionSection extends Component {
  /*constructor(props) {
    super(props);
    // console.log(props);
  }*/

  componentDidMount() {}

  render() {
    return (
      <div
        style={{
          width: "100%",
          height: "130",
          borderRadius: 5,
          backgroundColor: "#057748",
          margin: "auto",
          paddingTop: 20,
          paddingBottom: 20,
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <p style={{ color: "white", marginLeft: 20 }}>Aktion</p>
        <div
          id="test"
          style={{
            display: "flex",
            width: "100%",
            height: "auto",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          {this.props.children.map((c, i) => {
            let lPadding = 0;
            if (i !== 0) {
              lPadding = 10;
            }
            return (
              <div
                key={i}
                style={{
                  marginLeft: lPadding,
                  display: "flex",
                  flexDirection: "column",
                  cursor: "pointer"
                }}
              >
                {c}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/ActionSection.js